import React, { useCallback, useEffect, useRef } from "react";
import { loadStripe, StripeEmbeddedCheckout } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { RootState } from "@/src/State/store";
import { useSelector } from "react-redux";


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);
type EmbeddedCheckoutProps = {
  priceId: string;
  quantity: number;
  productName: string;
};

const EmbeddedCheckout1: React.FC<EmbeddedCheckoutProps> = ({ priceId, quantity, productName }) => {



  const accountId = useSelector((state: RootState) => state.authentication.account_id);
  const AdvUrl = useSelector((state: RootState) => state.authentication.apiURL);
  const token = document.cookie
      .split('; ')
      .find((row) => row.startsWith('AuthToken='))?.split('=')[1];
      
  const fetchClientSecret = useCallback(() => {
    // Create a Checkout Session

    const id = accountId;
    console.log(id, 'userid')
    return fetch(`${AdvUrl}/CreateCheckoutSession`, {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization": `Bearer ${token}`, },
      body: JSON.stringify({ priceId, quantity, productName, id }),
    })
      .then((res) => res.json())
      .then((data) => data.clientSecret);
  }, []);

  

    
  const options = { fetchClientSecret };


  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default EmbeddedCheckout1;